import React, { useEffect, useState } from 'react'
import { sanityClient, urlFor } from '../../sanity/client'
import { brandsQuery } from '../../sanity/queries'
import './Brands.css'

const Brands = () => {
  const [brands, setBrands] = useState([])

  useEffect(() => {
    sanityClient.fetch(brandsQuery).then(setBrands)
  }, [])

  if (!brands.length) return null

  return (
    <div className="brands-logos">
      <div className="logos-slide">
        {[...brands, ...brands].map((brand, index) => (
          <img
            key={`${brand._id}-${index}`}
            src={urlFor(brand.logo).url()}
            alt={brand.name}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  )
}

export default Brands
